export default "__VITE_ASSET__3b78773e__"